// extracted by mini-css-extract-plugin
export default {"container":"w4N45ytx2yLJw3BuEIcN","title":"swf3YrDPKoBav8unuFLv","note":"KNESGsjOe6ZlTuyHVySx"};